export interface ProductGetFeesParameters {
  assessmentType: string;
  variant: string;
  employeeNum: string;
  accountId: string;
  bundleProductId: string;
  fastTrack?: boolean;
}
